import styled from 'styled-components';

interface InfoBoxProps {
    $type?: 'primary' | 'secondary';
}

export const InfoBox = styled.div<InfoBoxProps>`
    border-radius: 8px;
    border: 1px solid
        ${({theme, $type = 'secondary'}) =>
            $type === 'primary'
                ? theme.colors.primary?.main
                : theme.colors.secondary?.main};
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: white;

    > h1 {
        margin: 0;
        border-radius: 6px;
        background-color: ${({theme, $type = 'secondary'}) =>
            $type === 'primary'
                ? theme.colors.primary?.main
                : theme.colors.secondary?.main};
        font-weight: bold;
        border-bottom-left-radius: 0;
        font-size: 1em;
        padding-left: 15px;
        padding-right: 15px;
        flex-shrink: 0;
    }
`;
